<h3 style="margin-top: 0; margin-bottom: 0; color: #028da8;"><i class="fa-solid fa-users"></i> {{ stats?.total }} Users</h3>
<p class="hide">{{ stats?.verified }} Verified</p>